module.exports = __webpack_public_path__ + "img/interify_black.53ba1057.svg";